import { Pipe, PipeTransform } from '@angular/core';

/** Turns 'invoice/proof-of-purchase' into 'invoice / proof of purchase'. */
@Pipe({
    name: 'removeDash',
    standalone: true
})
export class RemoveDashPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return (value ?? '').toLowerCase().replace(/-/g, ' ').replace(/\//g, ' / ');
    }
}
